module.exports = __webpack_public_path__ + "img/commercialInsurance.73c333da.png";